import React, { useState, FC } from 'react';
import Tooltip, { THEME } from '@mos-cat/tooltip';

import flagman from '@assets/flagman-alt.svg';
import wheelchair from '@assets/wheelchair.svg';
import camera from '@assets/camera.svg';
import wifi from '@assets/wifi.svg';
import additional from '@assets/additional.svg';

import st from './Special.module.css';

type SpecialProps = {
  office: {
    auxiliaryList?: any;
    type: string;
  };
  isDetailed?: boolean;
};

const Special: FC<SpecialProps> = ({ isDetailed = false, office }) => {
  const { auxiliaryList, type } = office;

  const getAuxiliaryServiceIcon = (id) => {
    switch (id) {
      case 'camera':
        return camera;
      case 'wifi':
        return wifi;
      case 'wheelchair':
        return wheelchair;
      case 'additional':
        return type === 'flagman' || type === 'palace' ? flagman : additional;
      default:
        return additional;
    }
  };

  const capitalText = (str) => (str ? str[0].toUpperCase() + str.slice(1) : '');

  const getAuxiliaryServiceDescription = (list: [{ description: string }]) =>
    list.map((item) => capitalText(item.description)).join(',\n');

  const [idOfShowedTooltip, setShowTooltip] = useState(null);

  const hasSpecial = Object.keys(auxiliaryList).length;
  if (!hasSpecial) return null;

  return (
    <div className={isDetailed ? st.containerBig : st.container}>
      {!!hasSpecial &&
        Object.keys(auxiliaryList).map((key) => (
          <Tooltip
            modal
            key={key}
            wrapperClassName={`${st.popover}  ${
              key === 'additional' ? st.additional : ''
            }`}
            considerHeader
            floating
            theme={THEME.HINT}
            open={key === idOfShowedTooltip}
            content={getAuxiliaryServiceDescription(auxiliaryList[key])}
          >
            <div
              className={st.wrapper}
              onMouseOver={() => setShowTooltip(key)}
              onMouseOut={() => setShowTooltip(null)}
              onFocus={() => setShowTooltip(null)}
              onBlur={() => setShowTooltip(null)}
            >
              <img src={getAuxiliaryServiceIcon(key)} alt="" />
            </div>
          </Tooltip>
        ))}
    </div>
  );
};

export default Special;
